export const areas = [

  {
    name: "Hoodi",
    centers: [
      { id: 79, km: 5, location: "https://maps.app.goo.gl/1sScRzwaRTWVHLBK9" },
    ],
  },
  {
    name: "Chikkabanavara",
    centers: [
      { id: 91, km: 5, location: "https://maps.app.goo.gl/7EbrGiQV3D6QmXYz6" },
    ],
  }, 
  {
    name: "Kothnur Narayanapura",
    centers: [
      { id: 96, km: 5, location: "https://maps.app.goo.gl/pAt4Vz2BwsduQ9Ys8" },
    ],
  },
  {
    name: "Thanisandra",
    centers: [
      { id: 96, km: 5, location: "https://maps.app.goo.gl/pAt4Vz2BwsduQ9Ys8" },
    ],
  },
  {
    name: "Bellandur",
    centers: [
      { id: 83, km: 5, location: "https://maps.app.goo.gl/irEQE5998eRUARz58" },
    ],
  },
  {
    name: "G B Palya",
    centers: [
      { id: 76, km: 5, location: "https://maps.app.goo.gl/Wwzp55KxoA1tu1oa8" },
    ],
  },
  {
    name: "Akshayanagar",
    centers: [
      { id: 90, km: 5, location: "https://maps.app.goo.gl/yJ9h3Y9Vzuq8ohYA9" },
    ],
  },
  {
    name: "Varthur",
    centers: [
      { id: 84, km: 5, location: "https://maps.app.goo.gl/uHwGHahUbsESrdgbA" },
    ],
  },
  {
    name: "J.P Nagar",
    centers: [
      { id: 94, km: 5, location: "https://maps.app.goo.gl/GFV4yLkMNRUG7FhF6" },
    ],
  },
  {
    name: "Kasturi Nagar",
    centers: [
      { id: 78, km: 5, location: "https://maps.app.goo.gl/KCrVs68KTR611H3E9" },
    ],
  },
  {
    name: "Hebbal",
    centers: [
      { id: 70, km: 5, location: "https://maps.app.goo.gl/iAdGytxJk8yYVbDK6" },
      { id: 77, km: 5, location: "https://maps.app.goo.gl/dtF9wZKi7UpjJYE59" },
    ],
  },
  {
    name: "Manyata Tech Park",
    centers: [
      { id: 70, km: 5, location: "https://maps.app.goo.gl/iAdGytxJk8yYVbDK6" },
      { id: 77, km: 5, location: "https://maps.app.goo.gl/dtF9wZKi7UpjJYE59" },
    ],
  },
  {
    name: "Sahakar Nagar",
    centers: [
      { id: 77, km: 5, location: "https://maps.app.goo.gl/dtF9wZKi7UpjJYE59" },
    ],
  },
  {
    name: "Kadugodi, Whitefield",
    centers: [
      { id: 85, km: 5, location: "https://maps.app.goo.gl/NXNFkqiiYSkJT3bP8" },
    ],
  },
  {
    name: "Whitefield",
    centers: [
      { id: 79, km: 5, location: "https://maps.app.goo.gl/1sScRzwaRTWVHLBK9" },
      { id: 85, km: 5, location: "https://maps.app.goo.gl/NXNFkqiiYSkJT3bP8" },
    ],
  },
  {
    name: "Gottigere",
    centers: [
      { id: 94, km: 5, location: "https://maps.app.goo.gl/GFV4yLkMNRUG7FhF6" },
      { id: 87, km: 5, location: "https://maps.app.goo.gl/JFLZrKWXkVJaDxMS8" },
    ],
  },

  {
    name: "Bannerghatta Road",
    centers: [
      { id: 94, km: 5, location: "https://maps.app.goo.gl/GFV4yLkMNRUG7FhF6" },
      { id: 87, km: 5, location: "https://maps.app.goo.gl/JFLZrKWXkVJaDxMS8" },
    ],
  },
];



